window.addEventListener("load", function () {
  const popup = document.getElementById("welcome-popup");
  const wrapper = document.querySelector("#welcome-popup .wrapper");
  const inhale = document.querySelector(".inhale");
  const exhale = document.querySelector(".exhale");
  const skipButton = document.getElementById("skip-popup");
  const breathingState = document.getElementById("breathing-state");
  const breathingSubtitle = document.querySelector("#breathing-state .subtitle");
  const revealSquare = document.getElementById('reveal-square');
  const welcomeState = document.getElementById("welcome-state");
  const emailState = document.getElementById("email-state");
  const successState = document.getElementById("success-state");
  const successNameSpan = document.getElementById("success-name");
  const klaviyoForm = document.getElementById("klaviyo-popup-form");
  const nameInput = document.getElementById("popup-name-input");
  const emailInput = document.getElementById("popup-email-input");
  const submitButton = document.getElementById("popup-email-submit");

  if (localStorage.getItem("popupSeen")) {
    popup.style.display = "none";
    return;
  }

  // One shared motion language for the whole popup: fade + settle-in
  // from 10px below on power3.out, fade + drift-up 8px on the way out.
  // Used for inhale/exhale, the subtitle+skip, and every state crossfade.
  const EASE = "power3.out";
  const EASE_SOFT = "power2.inOut";
  const IN_Y = 10;
  const OUT_Y = -8;

  // GSAP now owns .wrapper's transform entirely, so we replicate the
  // CSS centering (translate(-50%,-50%)) via xPercent/yPercent instead
  // of letting GSAP overwrite it.
  gsap.set(wrapper, { xPercent: -50, yPercent: -50, scale: 0.96, y: 12 });
  gsap.set([welcomeState, emailState, successState], { opacity: 0, y: IN_Y });

  // Breathing-state entrance order: inhale word first, then the
  // subtitle + skip together, then the stamp reveal.
  gsap.set([inhale, exhale, breathingSubtitle, skipButton], { y: IN_Y });
  gsap.set([breathingSubtitle, skipButton], { opacity: 0 });
  gsap.set(revealSquare, { attr: { x: 105, y: 106, width: 0, height: 0 } });

  const fadeIn = (el, duration) =>
    gsap.fromTo(el, { opacity: 0, y: IN_Y }, { opacity: 1, y: 0, duration, ease: EASE });

  const fadeOut = (el, duration) =>
    gsap.to(el, { opacity: 0, y: OUT_Y, duration, ease: EASE });

  const closePopup = () => {
    gsap.to(popup, {
      opacity: 0,
      duration: 0.8,
      ease: EASE_SOFT,
      onComplete: () => {
        popup.style.display = "none";
        localStorage.setItem("popupSeen", "true");
      }
    });
  };

  // Generic elegant crossfade between two states: the outgoing state
  // drifts up slightly while fading, then the incoming state settles
  // in from a touch below — same motion language everywhere.
  const crossfadeTo = (fromEl, toEl, onSwitch) => {
    const tl = gsap.timeline();
    tl.to(fromEl, { opacity: 0, y: OUT_Y, duration: 0.5, ease: EASE }, 0);
    tl.call(() => {
      fromEl.style.display = "none";
      fromEl.classList && fromEl.classList.remove("active");
      if (onSwitch) onSwitch();
      toEl.style.display = "flex";
      toEl.classList && toEl.classList.add("active");
    });
    tl.fromTo(toEl, { opacity: 0, y: IN_Y }, { opacity: 1, y: 0, duration: 0.7, ease: EASE }, "-=0.05");
    return tl;
  };

  const showWelcomeState = () =>
    crossfadeTo(breathingState, welcomeState, () => popup.classList.remove("exhale-active"));

  const showEmailState = () =>
    crossfadeTo(welcomeState, emailState, () => wrapper.classList.add("email-active"));

  const showSuccessState = (name) => {
    successNameSpan.textContent = name;
    return crossfadeTo(emailState, successState);
  };

  skipButton.addEventListener("click", closePopup);

  if (klaviyoForm) {
    klaviyoForm.addEventListener("submit", async (e) => {
      e.preventDefault();
      const name = nameInput.value.trim();
      const email = emailInput.value.trim();
      submitButton.textContent = "Joining...";
      submitButton.disabled = true;
      try {
        await fetch("https://a.klaviyo.com/client/subscriptions?company_id=UxwiDq", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "revision": "2024-10-15"
          },
          body: JSON.stringify({
            data: {
              type: "subscription",
              attributes: {
                profile: {
                  data: {
                    type: "profile",
                    attributes: {
                      email: email,
                      first_name: name
                    }
                  }
                }
              },
              relationships: {
                list: {
                  data: { type: "list", id: "UcZhfQ" }
                }
              }
            }
          })
        });
        showSuccessState(name);
        setTimeout(closePopup, 4000);
      } catch (error) {
        submitButton.textContent = "Join";
        submitButton.disabled = false;
        console.error("Error subscribing:", error);
      }
    });
  }

  // Single master timeline for the intro sequence: popup entrance,
  // inhale/exhale breathing + stamp reveal, then welcome → email.
  const master = gsap.timeline({ delay: 0.05 });

  master.to(popup, { opacity: 1, duration: 0.6, ease: EASE_SOFT });
  master.to(wrapper, { scale: 1, y: 0, duration: 0.7, ease: EASE }, "<");

  // 1) inhale word — same fade+settle language as everything else
  master.addLabel("inhaleStart", "+=0.15");
  master.add(fadeIn(inhale, 0.7), "inhaleStart");

  // 2) subtitle + skip, together, right after
  master.addLabel("subtitleStart", "inhaleStart+=0.6");
  master.add(fadeIn([breathingSubtitle, skipButton], 0.6), "subtitleStart");

  // 3) the stamp reveal
  master.addLabel("stampStart", "subtitleStart+=0.4");
  master.to(revealSquare, {
    attr: { x: -25, y: -24, width: 260, height: 260 },
    duration: 4,
    ease: "power1.out"
  }, "stampStart");

  master.addLabel("inhaleOut", "inhaleStart+=4.5");
  master.add(fadeOut(inhale, 0.7), "inhaleOut");

  master.addLabel("exhaleStart", "inhaleOut+=0.5");
  master.add(fadeIn(exhale, 0.7), "exhaleStart");
  master.call(() => popup.classList.add("exhale-active"), null, "exhaleStart");
  master.to(revealSquare, {
    attr: { x: 105, y: 106, width: 0, height: 0 },
    duration: 4,
    ease: "power1.in"
  }, "exhaleStart");

  master.add(showWelcomeState, "exhaleStart+=4");
  master.add(showEmailState, "+=3.8");
});
